<template>
  <div class="LoaderContainer" :class="{ small: small }">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      style="margin: auto; display: block; shape-rendering: auto"
      width="200px"
      height="200px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <path
        d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50"
        fill="#84bc47"
        stroke="none"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          dur="1s"
          repeatCount="indefinite"
          keyTimes="0;1"
          values="0 50 51;360 50 51"
        />
      </path>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    small: {
      default: false,
    },
  },
};
</script>
<style scoped lang="scss">
.LoaderContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 50vh;
  padding: 20px;
  svg {
    background: transparent;
  }
  &.small {
    min-height: 250px;
    svg {
      max-width: 100px;
    }
  }
  &.loader-xs {
    min-height: 160px;
    max-height: 160px;
    svg {
      max-width: 60px;
      max-height: 100px;
    }
  }
}
</style>
